import { render, staticRenderFns } from "./autoUpShow.vue?vue&type=template&id=ef1f59f0"
import script from "./autoUpShow.vue?vue&type=script&lang=js"
export * from "./autoUpShow.vue?vue&type=script&lang=js"
import style0 from "./autoUpShow.vue?vue&type=style&index=0&id=ef1f59f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports